const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Files Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Files', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/media/:subresource/:fileId', null, {
    find: {params: {subresource: '', type: 'file'}, method: 'GET', isArray: true},
    get: {params: {subresource: 'file', fileId: ''}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count', type: 'file'}, method: 'GET', isArray: false},
    create: {params: {subresource: 'files'}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    duplicate: {params: {subresource: '', fileId: 'duplicate'}, method: 'POST', isArray: false},
    boxSource: {params: {subresource: 'source'}, method: 'POST', isArray: false},
    checkBox: {params: {subresource: 'check-box'}, method: 'POST', isArray: false},
    remove: {params: {subresource: '', type: 'file'}, method: 'DELETE', isArray: false}
  });

}]);
